var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React from "react";
import styled from "styled-components";
import Icon from "../../Icon";
var Svg = styled(Icon)(templateObject_1 || (templateObject_1 = __makeTemplateObject([""], [""])));
export var CrossThin = function (_a) {
    var _b = _a.color, color = _b === void 0 ? "#E2665C" : _b, _c = _a.width, width = _c === void 0 ? 24 : _c, _d = _a.height, height = _d === void 0 ? 24 : _d, className = _a.className;
    return (React.createElement("div", { style: { width: width, height: height }, className: className },
        React.createElement(Svg, { viewBox: "0 0 24 24 " },
            React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12.7071 12.1924L16.9497 7.94975L16.2426 7.24264L12 11.4853L7.75736 7.24264L7.05025 7.94975L11.2929 12.1924L7.05025 16.435L7.75736 17.1421L12 12.8995L16.2426 17.1421L16.9497 16.435L12.7071 12.1924Z", fill: color }))));
};
var templateObject_1;
